import { Outlet } from "react-router-dom"
import PageContent from "~/ui/PageContent"

const SearchScreen = () => {
  return (
    <PageContent>
      <Outlet />
    </PageContent>
  )
}

export default SearchScreen
